import { ModalTestDefinition } from './modal-test-definition'
import { TestResultTable } from './modal-test-result-inner'
export { ModalTestDefinition, TestResultTable }
